<template>
    <div class="list-dialog">
        <el-dialog :visible="visible" title="续签待办详情" width="800px" @close="visible = false">
            <table-box class="prescreen" v-loading="renewalList.tableLoading" :selection="config.selection"
                :control="false" :columns="config.columns" :height="config.height"
                :tableData="renewalList.totalData" :actions="config.actions"
                :allowRowClick="false" :rows="renewalList.totalData">
                <template #col-append="{col, row, rIndex}">
                    <span v-if="col.prop === 'contractCode'" class="click-text" @click="goDetail(row)">{{ row[col.prop] }}</span>
                </template>
            </table-box>
            <div class="footer-box">
                <lots-pagination @size-change="renewalList.sizeChange"
                    :current-page.sync="renewalList.pageNo" @current-change="renewalList.pageChange"
                    size="small" layout="total, sizes, prev, pager, next, jumper"
                    :total="renewalList.pageTotal" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, getCurrentInstance } from '@vue/composition-api';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { tableConfig } from './config.js';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import _ from 'lodash';
import { getContractRenewalStatisticsByCompanyDetail, getContractRenewalStatisticsByIndustryDetail, getContractRenewalStatisticsByUserDetail } from '@mdm/api/pendingManage/renewalPending.js';

export default {
    name: 'renewalPending',
    components: {
        lotsPagination,
        tableBox
        // Paper,
        // listLayoutPaper,
        // searchBox,
        // lotsButton
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(_.cloneDeep(tableConfig));
        const visible = ref(false);
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition = { ...condition, ...params };
                return condition;
            };
            afterGetList (res) {
                if (res && +res.code === 0) {
                    renewalList.pageTotal.value = res.data.totalCount;
                    renewalList.totalData.value = res.data.list || [];
                }
            };
        }
        const renewalList = new AccountListClass({
            Api: {
                listApi: getContractRenewalStatisticsByIndustryDetail // 查询接口
            }
        });
        let params = {};
        const openDialog = (type, item, paramsData) => {
            visible.value = true;
            params = { ...paramsData };
            switch (type) {
            case 'industry':
                // 行业
                params.industryCategoriesCode = item.industryCategoriesCode;
                renewalList.listApi = getContractRenewalStatisticsByIndustryDetail;
                break;
            case 'company':
                // 分公司
                params.companyCode = item.companyCode;
                renewalList.listApi = getContractRenewalStatisticsByCompanyDetail;
                break;
            case 'personal':
                // 个人
                params.handlerCode = item.handlerCode;
                renewalList.listApi = getContractRenewalStatisticsByUserDetail;
                break;
            default:
                break;
            }
            renewalList.getList();
        };

        const goDetail = (row) => {
            // 去续签订单详情页
            visible.value = false;
            ctx.$router.push({ path: '/mod/mdm/contract-registration', query: { id: row.id, from: 'renewalPending' } });
        };

        return {
            visible,
            config,
            renewalList,
            openDialog,
            goDetail
        };
    }
};

</script>

<style scoped lang="less">
.list-dialog{
    .footer-box{
        padding: 20px 0;
        display: flex;
        justify-content: right;
        align-items: center;
    }
}
</style>
